import type { ReactNode } from 'react';
import type { Permission } from '@barbeiropro/contracts';
import { useSession } from '@/lib/session';
import { EmptyState } from '@/components/shared/states';

/** Esconde a tela para quem não tem permissão. A checagem real é sempre no backend. */
export function RequirePermission({ anyOf, children }: { anyOf: Permission[]; children: ReactNode }) {
  const { can } = useSession();
  if (!anyOf.some(can)) {
    return <EmptyState title="Acesso restrito" description="Seu papel nesta barbearia não inclui esta área. Fale com o proprietário." />;
  }
  return <>{children}</>;
}
